import { NavLink } from "react-router-dom";
export default function SubCategory({ title, subCategory, categoryId }) {
  return (
    <ul className="digi_subcat-menus">
      <div className="digi_subcat-head w-100 mb-4"></div>
      <div className="digi_subcat_boxs">
        <ul className="digi_subcat-menu ">
          <li className="digi_subcat-item digi_subcat-title">
            <span className="digi_subcat-link font-14-700">{title}</span>
          </li>
          {subCategory?.length > 0 ? (
            <div style={{ marginTop: "-15px" }}>
              {subCategory?.map((val, ind) => {
                return (
                  <NavLink
                    to={`/category/${val.id}`}
                    target={"_blank"}
                    className="d-block text-center text-decoration-none "
                  >
                    <li className="digi_subcat-item mb-3">
                      <span className="digi_subcat-link"> {val.txt}</span>
                    </li>
                  </NavLink>
                );
              })}
            </div>
          ) : (
            <span className="digi_subcat-link">
              زیر دسته بندی برای این آیتم وجود ندارد.{" "}
            </span>
          )}
        </ul>
      </div>
    </ul>
  );
}
